<p-table [columns]="columns" [value]="items" [rowHover]="true" [responsive]="true" [scrollable]="scrollable" [scrollHeight]="scrollHeight" 
    styleClass="p-datatable-sm" >
    <ng-template pTemplate="header" let-columns>
        <tr >
            <th style="justify-content: center; background-color: gainsboro;" *ngFor="let col of columns">{{ col.label }}</th>
        </tr>
    </ng-template>
    <ng-template pTemplate="body" let-item>
        <tr>
            <ng-container *ngFor="let col of columns">
                <ng-container>
                    <td *ngIf="col.type === 'id'" style="width:8%; min-width:8rem;">
                        {{ item[col.field] }}
                    </td>
                    <td *ngIf="col.type === 'text'">
                        {{ item[col.field] }}
                    </td>
                    <td style="justify-content: end;" *ngIf="col.type === 'number'">
                        {{ item[col.field] | currency: '': '': '0.0-0': 'es-PY' }}
                    </td>
                    <ng-container *ngIf="col.type === 'boolean'">
                        <td *ngIf="item[col.field] === true">
                            <i class="pi pi-check-circle" style="color: green; font-size: 1.5rem;"></i>
                        </td>
                        <td *ngIf="item[col.field] === false">
                            <i class="pi pi-times-circle" style="color: red; font-size: 1.5rem;"></i>
                        </td>
                    </ng-container>
                    <td *ngIf="col.type === 'date'">
                        {{ item[col.field] | date: 'dd/MM/yyyy' }}
                    </td>
                    <td *ngIf="col.type === 'datetime'">
                        {{ item[col.field] | date: 'dd/MM/yyyy HH:mm:ss' }}
                    </td>
                    <td *ngIf="col.type === 'multiselect'">
                        <!-- <span [class]="'custom-badge status-' + (item.inventoryStatus ? item.inventoryStatus.toLowerCase() : '')">{{ options[col.field] }}</span> -->
                        <span [class]="'custom-badge status-qualified'">{{ getOptionLabel(col.options, item[col.field] ) }}</span>
                    </td>
                </ng-container>
            </ng-container>
        </tr>
    </ng-template>
</p-table>